const es = {
    appNav: {
        admin: {
            training: "Formación",
        },
    },
    splashScreen: {
        intro: "HABLA CON",
        welcome: "Bienvenido a IVE",
        scenarioSelection: "Choose your scenario"
    },
    statistics: {
        goToStatistics: "Ir a estadísticas",
        dialogs: {
            header: "Diálogos",
            description: "Consulte la información sobre los diálogos: temas populares, preguntas incomprendidas, etc...",
        },
        documents: {
            header: "Documentos",
            description: "Consulte la información en los documentos: Temas más populares, documentos más solicitados, etc...",
        },
        classification: {
            header: "Clasificación",
            description: "Consulte la información sobre la Clasificación: resultados de entrenamiento, precisión, etc...",
        },
        mail: {
            header: "Correo electrónicos",
            description: "Consulte la información de enrutamiento del correo electrónico: resultados de clasificación, precisión, etc.",
        },
    },
    account: {
        title: "Account",
    },
    settings: {
        title: "Ajustes",
        save: "Guardar",
        language: {
            header: "Idioma",
            chooseLanguage: "Elegir idioma",
        },
        notificationsType: {
            header: "Tipo de notificaciones",
            chooseNotificationsType: "Elige el tipo de notificación",
        },
        dialogicPlatform: {
            header: 'Diálogos',
            chooseLanguage: "Elegir idioma",
            engine: {
                chooseEngine: "Elegir el motor dialógico"
            },
        },
        emailRouting: {
            header: "Correos electrónicos",
            enable: "Habilitar el reenvío automático de correo electrónico",
            description: "Permite la clasificación de los correos electrónicos para enrutamiento automático.",
        },
        webInformationRetrieval: {
            header: "Web Radar",
            enable: "Habilitar el Web Radar",
            description: "Permitir el análisis de los sitios web más relevantes para obtener información automáticamente",
        },
        imageCaptioning: {
            header: "Subtitulado de imágenes",
            enable: "Habilitar Subtitulado de imágenes",
            description: "Permitir el análisis de imágenes para obtener descripciones textuales",
        },
    },
    globalControls: {
        notifications: {
            header: "notificaciones",
            noNotifications: "Sin notificaciones",
            deleteAll: "Borrar todo",
            content: {
                showMore: "Cliquee para ver más...",
                showLess: "Cliquee para ver menos...",
            },
        },
        fileInput: {
            dragAndDrop: "Arrastra tu archivo o haz clic aquí para seleccionarlo desde tu PC!",
            selectFile: "escoja un archivo",
            uploadFiles: "Carga archivos"
        },
        fileViewer: {
            latestVersion: "Última versión",
            lastModified: "Última modificación",
            author: "Autor",
            version: "Versión",
        },
    },
    training: {
        ontology: {
            title: "Ontología",
            upload: {
                titlePage: "Carga tu diccionario",
                subtitle: "Carga un file csv",
                uploadMessage: "Carga ontología",
                buttonTitle: "Carga",
            },
        },
        classes: {
            title: "Clases",
            upload: {
                uploadMessage: "Carga",
                buttonTitle: "Carga",
            },
            addDocuments: "Adjuntar documentos",
            reset: "Reset Entrenamiento",
            selectClass: {
                chooseClass: "Seleccionar clase",
                addClass: "Añadir nueva clase",
                description: "Escriba el nombre de la nueva clase que desea crear.",
                name: "Nombre de la nueva clase",
                confirm: "Confirmar",
                close: "Cerrar"
            },
            wait: "Espere a la carga, por favor...",
            navigationDrawer: {
                deleteClass: "Eliminar clase",
                keywords: "Keywords",
            },
            deleteDialog: {
                title: "Eliminar clase",
                text: "¿Está seguro de que va a eliminar esta clase?",
                yes: "Sì",
                no: "No"

            },
            chart: {
                title: "Text classifier training",
                description: "Esta tabla muestra las clases en las que se entrena el clasificador. Puede interactuar y ver cómo se relacionan las clases entre sí.",
                text: "Esta tabla muestra las clases en las que se entrena el clasificador. Puede interactuar y ver cómo se relacionan las clases entre sí.",
            },
        },
        conversation: {
            title: "Conversación",
            intent: "Intentos",
            createIntent: {
                name: "Crea un intento",
                description: "Escriba el nombre del nuevo intento",
                label: "Nombre del nuevo intento",
                save: "Salva",
                close: "Cerrar"

            },
            questions: "Preguntas",
            answers: "Respuestas",
            attachments: "Adjuntos",
            save: "Salva",
            delete: "Eliminar"
        },
        files: {
            title: "Carga archivos",
            otherResults: "Otros resultados",
            upload: {
                titlePage: "Carga tus archivos",
                subtitle: "Voy a clasificarlos!",
                uploadMessage: "Carga",
                buttonTitle: "Carga",
            },
            toolbar: {
                storage: "Archivos",
                filter: {
                    tip: "Filtrar por nombre",
                    label: "Filtro...",
                    caseSensitive: "Filtro case sensitive",
                },
                createNew: {
                    tip: "Crear un nuevo documento",
                    windowTitle: "Nuevo Documento",
                    subToolbar: {
                        save: "Salva",
                    },
                },
                uploadFiles: {
                    tip: "Carga documentos",
                },
                deleteAll: {
                    tip: "Eliminar todos los documentos",
                },
            },
            fileResult: {
                deleteAll: "Eliminar todo",
            },
            base: {
                deleteAllTitle: "Eliminar todos los documentos?",
                deleteAllDescription: "¿Está seguro de que desea eliminar todos los documentos?",
                confirmDelete: "Eliminar todo",
                cancelDelete: "Anular",
                emptyMessage_1: "Ningún documento.",
                emptyMessage_2: "Clic en el botón de cargar",
                emptyMessage_3_1: "para cargar documentos.",
                emptyMessage_3: "para cargar o hacer clic en el icono de creación",
                emptyMessage_4: "para crear uno nuevo.",
            },
        },
    },
    testing: {
        classes:{
            title: "¿Quieres probar tu clasificador?",
            description: "Aquí puede testear tu clasificador",
            upload: {
                uploadMessage: "Clasificar",
                buttonTitle: "Clasificar",
            },
            table: {
                class: "Clase",
                confidence: "Confianza",
                noData: "Ningún dato disponible"
            },
        },
        search: {
            title: "Buscar",
        },
        talk: {
            title: "Háblame",
        },
        documentSimilarity: {
            title: "Similitud de documentos",
            upload: {
                titlePage: "Similitud de documentos",
                uploadMessage: "Carga un documento",
                buttonTitle: "Verificar similitud",
            }
        },
    },
};

export default es;
